import React from 'react';
import ProductFeature from './product_feature';
import ButtonGroupRadio from '../../call_list/activity_forms/button_group_radio';
import { faMap, faTableRows } from '@fortawesome/pro-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { setShowTableView, setCallListTableView } from 'bundles/connect/components/store/actions/ui';
import { selectCallListId } from '../../store/selectors/call_console';
import { selectCallListTableView, selectShowTableView } from '../../store/selectors/ui';

const MAP_VIEW = 'MAP_VIEW';
const TABLE_VIEW = 'TABLE_VIEW';

const TYPE_OPTIONS = [
  { icon: faMap, label: '', tooltip: 'Map View', value: MAP_VIEW },
  { icon: faTableRows, label: '', tooltip: 'Table View', value: TABLE_VIEW }
];

export default function OffMarketMapTableViewToggle() {
  const dispatch = useDispatch();
  const showTableView = useSelector(selectShowTableView);
  const callListTableView = useSelector(selectCallListTableView);
  const callListId = useSelector(selectCallListId);

  const mapView = showTableView ? TABLE_VIEW : MAP_VIEW;
  const callListView = callListTableView ? TABLE_VIEW : MAP_VIEW;

  const handleMapViewChange = () => {
    dispatch(setShowTableView(!showTableView));
  };
  const handleCallListViewChange = () => {
    dispatch(setCallListTableView(!callListTableView));
  };

  if (callListId) {
    return (
      <>
        {callListTableView ? (
          <ButtonGroupRadio
            checked={callListView}
            name="search_view"
            options={[...TYPE_OPTIONS].reverse()}
            onChange={handleCallListViewChange}
          />
        ) : (
          <div className="d-none d-xxl-block">
            <ProductFeature product="prospecting">
              <ButtonGroupRadio
                checked={callListView}
                name="search_view"
                options={[...TYPE_OPTIONS].reverse()}
                onChange={handleCallListViewChange}
              />
            </ProductFeature >
          </div >
        )}
      </>
    );
  } else {
    return (
      <>
        {showTableView ? (
          <ButtonGroupRadio
            checked={mapView}
            name="search_view"
            options={TYPE_OPTIONS}
            onChange={handleMapViewChange}
          />
        ) : (
          <div className="d-none d-xxl-block">
            <ProductFeature product="prospecting">
              <ButtonGroupRadio
                checked={mapView}
                name="search_view"
                options={TYPE_OPTIONS}
                onChange={handleMapViewChange}
              />
            </ProductFeature >
          </div >
        )}
      </>
    );
  }
}
